    var CreateCustomerModelCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state, createCustomerLoader, errorRouterService, errorScreenService, ERR) {
        var vm = this;
        // this variables stores all listeners to the http error to have
        // possibility to unsubscribe when scope destroy event calls
        var httpErrorsListeners = [];
        httpErrorsListeners.push(errorRouterService.subscribe(function (err) {
            if (err && err.status == 500) {
                invokeGetItemError();
                return $q.when(true);
            }
        }, { resourceName: 'getModels', status: '*' }));
        //trigger error screen
        function invokeGetItemError() {
            errorScreenService.error(true, ERR.CAN_NOT_GET_AVALIABLE_MODEL, {
                noFullScreen: true,
                template: 'template/errorscreens/can-not-get-avaliable-item',
                errorType: ERR.CAN_NOT_GET_AVALIABLE_MODEL,
                vinDecode: $scope.$parent.vinDecodeOptions
            });
        };
        //setVehicleModel
        //
        //@param {object} selected model object
        //
        //@description
        //Method calls when user select model
        vm.setVehicleModel = function (model) {
            var vehicle = customerModelService.getCurrentVehicle();
            if (vehicle) {
                vehicle.setModel(model);
                $scope.vehicleCreationData.selectedModel = model;
                $scope.ctrl.goToState($scope.ctrl.currentStateIndex + 1, $scope.vehicleCreationData.transmissions);
            };
        };

        function init() {
            var vehicle = customerModelService.getCurrentVehicle();
            if (vehicle) {
                var year = vehicle.getYear();
                createCustomerLoader.addPromise(
                    year.getModels()
                        .then(function (models) {
                            if (!models || models.length === 0) {
                                invokeGetItemError();
                                models = [];
                            }
                            $scope.vehicleCreationData.models = models.sort(function (a, b) {
                                return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1;
                            });
                        })
                        .catch(function (err) {
                            $log.error('Something went wrong', err);
                        }));
            };
        };
        //unsubscribe all http exception listeners
        $scope.$on('$destroy', function () {
            httpErrorsListeners.forEach(function (id) {
                errorRouterService.unsubscribe(id);
            });
        });
        //start
        init();
    };
    CreateCustomerModelCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'createCustomerLoader', 'errorRouterService', 'errorScreenService', 'errors'];

    module.exports = CreateCustomerModelCtrl;
